import React from 'react'
import SubCategoryListing from './SubCategoryListing'

export default function CategoryManagment() {
  return (
    <SubCategoryListing/>
  )
}
